export { default } from '@shikijs/langs/lua'
